import React from 'react';
import { Link } from 'react-router-dom';
import GuidePageLayout from '../../components/seo/GuidePageLayout';

const FREE_TRIAL_URL = 'https://buy.stripe.com/5kA6rt11z6Dw06YbII';

export default function HowItWorks() {
  return (
    <GuidePageLayout currentPath="/how-it-works">
      <h1>How Horse Racing Oracle works (UK Betfair)</h1>
      <p>
        Horse Racing Oracle is built for <strong>UK horse racing</strong> on <strong>Betfair</strong>. It is designed to
        operate automatically: when markets meet strict, predefined criteria, the system can place bets on your behalf
        according to the staking and limits you configure. Past performance does not guarantee future results; all
        betting carries risk.
      </p>

      <h2>What &quot;automation&quot; means here</h2>
      <p>
        Instead of manually scanning cards and prices, the product focuses on <strong>repeatable rules</strong>—for
        example field size, price bands, ratings and form signals—so decisions are applied consistently across racing
        days. You remain responsible for your account, stakes, and compliance with Betfair&apos;s terms and applicable
        law.
      </p>

      <h2>UK focus</h2>
      <p>
        The service is aimed at customers who bet on <strong>UK racing</strong> through Betfair. If you are outside the
        UK or Betfair restricts your account or jurisdiction, the product may not be suitable—see{' '}
        <Link to="/who-its-for">Who it&apos;s for</Link> and our <Link to="/terms-conditions">terms</Link>.
      </p>

      <h2>Risk management (high level)</h2>
      <p>
        Risk controls include staking modes such as a <strong>daily profit target</strong> (capped in the product) and{' '}
        <strong>percentage staking</strong>, so exposure scales with your balance rather than being ad hoc. Details are
        covered in <Link to="/staking-and-risk-controls">Staking &amp; risk controls</Link> and in our{' '}
        <Link to="/faqs">FAQs</Link>.
      </p>

      <h2>Betfair access</h2>
      <p>
        You connect your Betfair account through the in-app flow. We summarise permissions and security expectations in{' '}
        <Link to="/betfair-connection-and-security">Betfair connection &amp; security</Link>.
      </p>

      <div className="guideCta">
        <p className="guideCtaTitle">Ready to try the system?</p>
        <a
          className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 hover:from-primary-100 hover:to-primary-100 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          href={FREE_TRIAL_URL}
          rel="noopener noreferrer"
        >
          Start free trial
          <svg className="ml-2 -mr-1 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>
      </div>
    </GuidePageLayout>
  );
}
